import React from 'react';
import { Form, InputNumber } from 'antd';
import { NamePath } from 'rc-field-form/lib/interface';

type DecimalInputProps = {
  name: NamePath;
  label: string;
  value?: number;
  required?: boolean;
  disabled?: boolean;
  onChange?: (value: number) => void;
  hidden?: boolean;
  precision?: number;
  step?: number;
  min?: number;
  max?: number;
};

export function DecimalInput(props: DecimalInputProps) {
  const handleChange = (value: number) => {
    if (props.onChange) {
      props.onChange(value);
    }
  };
  return (
    <>
      <Form.Item name={props.name} label={props.label} rules={[{ required: props.required, message: `${props.label} is required` }]} hidden={props.hidden}>
        <InputNumber
          type="number"
          style={{ width: '100%' }}
          precision={props.precision ?? 2}
          step={props.step ?? 0.01}
          min={props.min ?? 0}
          max={props.max}
          value={props.value}
          onChange={(value) => {
            handleChange(value);
          }}
          disabled={props.disabled}
        />
      </Form.Item>
    </>
  );
}
